import { NgClass, NgStyle } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, HostBinding, inject, Input, OnInit } from '@angular/core';
import { DataStore } from '@compiere-ws/models/compiere-data-json';
import { PrimeAccordionComponent } from '@iupics-components/overrided/prime-accordion/prime-accordion.component';
import ButtonUiComponent from '@iupics-components/standard/fields/button-ui/button-ui.component';
import { WindowFactoryUtils } from '@iupics-manager/managers/ui-creator/window-factory/window-factory-utils';
import { AbstractDataContainer } from '@iupics-manager/models/abstract-datacontainer';
import { IupicsEvent } from '@iupics-manager/models/iupics-event';
import { AccordionModule } from 'primeng/accordion';
import { timer } from 'rxjs';
import { DynamicContainerDirective } from '../../../../iupics-util/directives/dynamic-container.directive';

@Component({
  selector: 'iu-accordion-ui',
  templateUrl: './accordion-ui.component.html',
  styleUrls: ['./accordion-ui.component.scss'],
  standalone: true,
  imports: [AccordionModule, NgStyle, NgClass, DynamicContainerDirective, PrimeAccordionComponent],
})
export default class AccordionUiComponent extends AbstractDataContainer implements OnInit, AfterViewInit {
  #cd = inject(ChangeDetectorRef);

  @Input()
  selected: boolean;

  isMandatory: boolean;

  @HostBinding('class.p-col-nopad') hasNoPad = false;

  protected contentNbCol = 2;

  ngOnInit() {
    super.ngOnInit();
    this.cssGrid = 'blade-full-width blade-grid-field';
    if (this.data) {
      if (!this.data.isCollapsedDefault) {
        this.selected = true;
      } else {
        this.selected = this.data.isSelected;
      }
      this.contentNbCol = this.data.nbCol;
    }
    this.isAccordion = true;
  }

  onChildUpdate(event: IupicsEvent) {}

  onSiblingUpdate(event: IupicsEvent) {}

  onRemoveComponent(event: IupicsEvent) {}

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.subscriptions.push(
      timer(0).subscribe(() => {
        for (const child of this.children) {
          const componentRef = WindowFactoryUtils.addContainerComponent({
            parent: this,
            item: child,
            isCssOnComponent: child.container ? child.isCssOnComponent : false,
          });
          if (componentRef.instance instanceof ButtonUiComponent) {
            componentRef.instance.itemData = child;
            if (child.processId > 0 && this.DOMParentComponent.data.componentName === 'EditTabUiComponent') {
              this.DOMParentComponent.registerProcess({
                tabId: this.tabId,
                isDisplay: false,
                readOnly: false,
                fieldID: child.data.fieldId,
                processId: child.processId,
                componentUUID: componentRef.instance.uuid,
                label: child.data.label,
              });
            }
          }
        }
        this.#cd.detectChanges();
        this.updateUI();
      })
    );
  }

  setMandatory() {
    // check if mandatory children are OK
    let found = false;
    for (let i = 0; i < this.DOMChildrenComponent.length && !found; i++) {
      const field = this.DOMChildrenComponent[i];
      // si autocomplete
      if (
        !found &&
        (field as any).isAutocompleteField === true &&
        field.isMandatory === true &&
        (field as any).displayCss !== 'none' &&
        ((field as any).fieldValue === undefined ||
          (field as any).fieldValue === null ||
          !((field as any).fieldValue instanceof Object))
      ) {
        found = true;
      }
      // si c'est autre qu'autocomplete
      if (
        !found &&
        field.isMandatory === true &&
        (field as any).displayCss !== 'none' &&
        ((field as any).fieldValue === undefined || (field as any).fieldValue === '')
      ) {
        found = true;
      }
    }
    this.isMandatory = found;
  }

  updateDisplay(dataStored: DataStore) {
    super.updateDisplay(dataStored);
    if (this.displayCss !== 'none') {
      this.displayCss = 'none';
      if (this.DOMChildrenComponent && this.DOMChildrenComponent.length > 0) {
        // pour toutes les row
        for (let i = 0; i < this.DOMChildrenComponent.length && this.displayCss === 'none'; i++) {
          const input = this.DOMChildrenComponent[i] as AbstractDataContainer;
          input.isFieldDisplay(dataStored).subscribe((displayed) => {
            if (displayed) {
              this.displayCss = 'inline';
            }
          });
        }
      }
    }
    this.hasNoPad = this.displayCss === 'none';
  }
}
